import React, { Fragment, useEffect, useReducer, useState } from 'react'
import { string } from 'prop-types'
import { navigate } from '@reach/router'
import styled from 'styled-components'
import ModalWindow from '../../shared/ModalWindow'
import ContentWrapper from '../../shared/ContentWrapper'
import Loader from '../../shared/Loader'
import TopButtonsWrapper from '../../shared/TopButtonsWrapper'
import PageDescription from '../../shared/PageDescription'
import StructuredTable from '../../shared/StructuredTable'
import Button from '../../shared/Button'
import { TEXT_SMALL } from '../../../constants'
import {
  SECONDARY_BUTTON,
  PRIMARY_BUTTON,
} from '../../../constants/buttonThemes'

import { fetchUsers, removeUser } from './actions'
import { initialState, reducer } from './reducer'

const Spacer = styled.div`
  padding-top: 10px;
`
const RowRadius = styled.div`
  .ReactTable .rt-tbody .rt-tr-group {
    border-radius: 5px;
  }
`

var selectedId = ''
const TableColumns = (
  t,
  organisationId,
  dispatch,
  page,
  deleteDialogVisible,
  setDeleteDialogVisible
) => [
  {
    Header: t('users_table_header1'),
    accessor: 'name',
  },
  {
    Header: t('users_table_header2'),
    accessor: 'email',
  },
  {
    Header: t('users_table_header3'),
    accessor: 'updatedAt',
    Cell: row => {
      const {
        original: { updatedAt },
      } = row
      return updatedAt
        ? t('dateValueInput', {
            value: new Date(updatedAt),
          })
        : ''
    },
  },
  {
    Cell: row => {
      const {
        original: { id },
      } = row
      return (
        <>
          <Button
            dataId={`remove-user-${id}`}
            onClick={() => {
              selectedId = id
              setDeleteDialogVisible(true)
            }}
            fontSize={TEXT_SMALL}
            theme={SECONDARY_BUTTON}
          >
            {t('button_remove').toUpperCase()}
          </Button>
          <ModalWindow
            visible={deleteDialogVisible}
            okText={t('button_delete')}
            onOk={() => {
              removeUser(organisationId, selectedId, t, dispatch, page)
              selectedId = ''
              setDeleteDialogVisible(false)
            }}
            okTheme={PRIMARY_BUTTON}
            onCancel={() => {
              setDeleteDialogVisible(false)
              selectedId = ''
            }}
            cancelTheme={SECONDARY_BUTTON}
            t={t}
          >
            {t('user_delete_confirmation')}
          </ModalWindow>
        </>
      )
    },
  },
]

const UserList = ({ t, organisationId }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { userList, userListState, pageTotal, page } = state
  const [deleteDialogVisible, setDeleteDialogVisible] = useState(false)
  const filteredOrganisation = window.location.search.split('usersOf=')[1]

  useEffect(
    () => {
      fetchUsers(organisationId, dispatch, page, t, filteredOrganisation)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [organisationId]
  )

  if (!userListState || userListState === 'FETCHING') {
    return <Loader />
  }

  return (
    <Fragment>
      <PageDescription
        heading={t('users')}
        description={t('users_description')}
      />

      <TopButtonsWrapper
        buttons={[
          {
            name: t('invite_user'),
            onClick: () => navigate(`/${organisationId}/admin/add-new-user`),
          },
        ]}
      />
      <Spacer />
      <ContentWrapper>
        <RowRadius>
          <StructuredTable
            columns={TableColumns(
              t,
              organisationId,
              dispatch,
              page,
              deleteDialogVisible,
              setDeleteDialogVisible
            )}
            data={userList}
            rowPadding
            rightAlignLastColumn
            page={page}
            pageSize={10}
            pageTotal={pageTotal}
            selectNextPage={() =>
              fetchUsers(organisationId, dispatch, page + 1, t)
            }
            selectPreviousPage={() =>
              fetchUsers(organisationId, dispatch, page - 1, t)
            }
            showPagination={false}
            sortable={false}
          />
        </RowRadius>
      </ContentWrapper>
    </Fragment>
  )
}

UserList.propTypes = {
  organisationId: string.isRequired,
}

export default UserList
